import React, { useState, useEffect, useRef } from 'react';
import "react-phone-input-2/lib/style.css";
import { setCurrentPageTitle } from '../../store/slices/pageSlice';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompanyProfiles, saveOrUpdateCompanyProfile } from '../../store/slices/companyProfileSlice';
import { useSnackbar } from 'notistack';
import AdminLoader from '../../components/common/loader/AdminLoader';
// import InputMask from "react-input-mask";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { fetchEmployees } from '../../store/slices/employeeAdminSlice';
// import { Building2 } from 'lucide-react';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import LocalPostOfficeOutlinedIcon from '@mui/icons-material/LocalPostOfficeOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import GpsFixedOutlinedIcon from '@mui/icons-material/GpsFixedOutlined';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import PublicIcon from '@mui/icons-material/Public';
import { useLoggedUser } from '../../utils/useLoggedUser';
import { resolveCountryInputConfig } from '../../utils/currencyUtils';
import { useNavigate } from 'react-router-dom';
const CompanyProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [comapanyName, setcomapanyName] = useState("");
  const [comapanyEmail, setcomapanyEmail] = useState("");
  const [comapanyContact, setcomapanyContact] = useState("");
  const [comapanyLink, setcomapanyLink] = useState("");
  // const [comapanyAddress, setcomapanyAddress] = useState("");
  console.log("comapanyContact", comapanyContact)
  const [companyLogo, setcompanyLogo] = useState("");
  const [oldLogo, setoldLogo] = useState("");
  const [AddressLine1, setAddressLine1] = useState("");
  const [AddressLine2, setAddressLine2] = useState("");
  const [pincode, setpincode] = useState();
  const [city, setcity] = useState("");
  const [isLoading, SetisLoading] = useState(false);
  const { profiles } = useSelector(state => state.companyProfile);
  const loggedEmployee = useLoggedUser();
  const fileInputRef = useRef(null); // Add this ref
  const [isDragging, setIsDragging] = useState(false); // Add this state
  const dragCounter = useRef(0); // Add this ref to track drag events
  const [isediting, setisediting] = useState(false); // Add this state

  const getFileNameFromPath = (path) => {
    if (!path) return null;
    const parts = path.split('_');
    return parts[parts.length - 1];
  };
  const oldLogoFileName = getFileNameFromPath(oldLogo);

  console.log("oldLogo", oldLogo)

  useEffect(() => {
    dispatch(setCurrentPageTitle("Company Profile"));
    dispatch(fetchCompanyProfiles());
    dispatch(fetchEmployees());
  }, [dispatch]);
  const normalizePhone = (phone, countryCode) => {
    if (!phone) return "";

    let str = String(phone).replace(/^\+/, "");

    // If countryCode is missing, just return digits
    if (!countryCode) return str;

    const cc = countryCode.replace("+", "");

    // Remove country code if already present
    if (str.startsWith(cc)) {
      str = str.slice(cc.length);
    }

    return cc + str;
  };
  useEffect(() => {
    if (!profiles?.length) return;
    if (!loggedEmployee?.countrycode) return;
    const phone = profiles[0]?.companycontactno;

    setcomapanyContact(
      normalizePhone(phone, loggedEmployee?.countrycode)
    );
  }, [profiles, loggedEmployee]);


  useEffect(() => {
    console.log("gsdgsd", profiles[0])
    setcomapanyName(profiles[0]?.companyname === "undefined" ? "" : profiles[0]?.companyname);
    setcomapanyEmail(profiles[0]?.companyemail === "undefined" ? "" : profiles[0]?.companyemail);
    // setcomapanyContact(profiles[0]?.companycontactno === "undefined" ? "" : profiles[0]?.companycontactno);
    setcomapanyLink(profiles[0]?.companylink === "undefined" ? "" : profiles[0]?.companylink);
    setoldLogo(profiles[0]?.logoPath === "undefined" ? "" : profiles[0]?.logoPath);
    setAddressLine2(profiles[0]?.companyaddresstwo === "undefined" ? "" : profiles[0]?.companyaddresstwo);
    setAddressLine1(profiles[0]?.companyaddress === "undefined" ? "" : profiles[0]?.companyaddress);
    setpincode(profiles[0]?.companypincode === 0 ? "" : profiles[0]?.companypincode);
    setcity(profiles[0]?.companycity === "undefined" ? "" : profiles[0]?.companycity);
    // const phone = profiles[0]?.companycontactno;

    // setcomapanyContact(
    //   normalizePhone(phone, loggedEmployee?.countrycode)
    // );


  }, [profiles, loggedEmployee]);


  const handleProfile = async () => {
    const contactString = String(comapanyContact || '');

    // Basic validations
    if (!comapanyName.trim()) {
      enqueueSnackbar("Company name is required", { variant: "error" });
      return;
    }

    if (!comapanyEmail.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(comapanyEmail)) {
      enqueueSnackbar("Valid company email is required", { variant: "error" });
      return;
    }

    if (!contactString.trim()) {
      enqueueSnackbar("Company contact number is required", { variant: "error" });
      return;
    }

    const cleanContact = contactString.replace(/\D/g, '');
    if (!/^\d{10,15}$/.test(cleanContact)) {
      enqueueSnackbar("Please enter a valid company contact", {
        variant: "error"
      });
      return;
    }

    const pincodeStr = String(pincode || '');

    if (defaultCountry === "in") {
      // India: exactly 6 digits
      const indianPincodeRegex = /^\d{6}$/;
      if (pincodeStr && !indianPincodeRegex.test(pincodeStr)) {
        enqueueSnackbar("pincode must be exactly 6 digits", { variant: "error" });
        return;
      }
    } else if (defaultCountry === "us") {
      // US: ZIP code validation
      // Format: 12345 or 12345-6789 (5 digits, optional hyphen, 4 digits)
      const usZipCodeRegex = /^\d{5}(-\d{4})?$/;
      if (pincodeStr && !usZipCodeRegex.test(pincodeStr)) {
        enqueueSnackbar("Pincode must be 5 or 9 digits", {
          variant: "error"
        });
        return;
      }

      // Additional check for minimum 5 digits (without hyphen)
      const digitsOnly = pincodeStr.replace(/\D/g, '');
      if (pincodeStr && digitsOnly.length < 5) {
        enqueueSnackbar("US ZIP code must have at least 5 digits", { variant: "error" });
        return;
      }
    }

    const formData = new FormData();
    formData.append('companyname', comapanyName);
    formData.append('companyemail', comapanyEmail);
    formData.append('companycontactno', comapanyContact);
    formData.append('companylink', comapanyLink);
    formData.append('companyaddress', AddressLine1);
    formData.append('companyaddresstwo', AddressLine2);
    formData.append('companypincode', pincode);
    formData.append('companycity', city);
    formData.append('companylogo', companyLogo);

    SetisLoading(true);

    try {
      await dispatch(saveOrUpdateCompanyProfile(formData)).unwrap();
      enqueueSnackbar("Company Profile Successfully Created", {
        variant: "success",
      });
      navigate("/dashboard/add-group", {
        state: { selectedDash: "Add Group", openSettings: true },
      });
    } catch (error) {
      console.error("Failed to create company profile:", error);
      const errorMessage =
        error?.error ||
        error?.message ||
        "Something went wrong. Please try again.";
      enqueueSnackbar(errorMessage, {
        variant: "error",
      });
    } finally {
      SetisLoading(false);
      dispatch(fetchCompanyProfiles());
      setcompanyLogo("")
    }
  };

  // const handleFileChange = (event) => {
  //   if (!event || !event.target || !event.target.files) return;

  //   const file = event.target.files[0]; // Get the uploaded file
  //   if (file) {
  //     setcompanyLogo(file); // Store the file in state
  //     enqueueSnackbar("File Uploaded Successfully", {
  //       variant: "success",
  //     });
  //   }
  // };
  const handleFileChange = (file) => {
    if (!file) return;

    // Check file type
    const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    if (!validTypes.includes(file.type)) {
      enqueueSnackbar("Please upload a PNG or JPG file", { variant: "error" });
      return;
    }

    // Check file size (e.g., 2MB max)
    const maxSize = 2 * 1024 * 1024; // 2MB in bytes
    if (file.size > maxSize) {
      enqueueSnackbar("File size should be less than 2MB", { variant: "error" });
      return;
    }

    // Set the file
    setcompanyLogo(file);
    enqueueSnackbar("File uploaded successfully", { variant: "success" });
  };

  // Handle file input change
  const handleInputChange = (event) => {
    if (!event?.target?.files?.length) return;
    const file = event.target.files[0];
    handleFileChange(file);
    setisediting(true)
  };

  // Drag and drop handlers
  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current += 1;
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current -= 1;

    // Only set to false when leaving the container entirely
    if (dragCounter.current === 0) {
      setIsDragging(false);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Don't set isDragging here to prevent state updates on every mouse move
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    dragCounter.current = 0; // Reset counter

    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      const file = files[0];
      handleFileChange(file);

      // Also update the file input for consistency
      if (fileInputRef.current) {
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        fileInputRef.current.files = dataTransfer.files;
      }
    }
  };

  // Add useEffect to clean up drag counter
  useEffect(() => {
    return () => {
      dragCounter.current = 0;
    };
  }, []);

  // Clear file function
  const handleClearFile = () => {
    setcompanyLogo(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    enqueueSnackbar("File removed", { variant: "info" });
  };




  const handleDownload = () => {
    if (!oldLogo) return;

    // Fetch the image first
    fetch(oldLogo)
      .then(response => response.blob())
      .then(blob => {
        // Create a blob URL
        const blobUrl = window.URL.createObjectURL(blob);

        // Create a temporary anchor element
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = oldLogoFileName || 'company_logo';
        link.style.display = 'none';

        // This is important for forcing download
        link.setAttribute('download', '');

        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      })
      .catch(error => {
        console.error('Error downloading image:', error);
      });
  };

  const { iso2: defaultCountry, onlyCountries: allowedCountries } =
    resolveCountryInputConfig({
      countrycode: loggedEmployee?.countrycode,
      region: loggedEmployee?.region,
    });

  // const formatPhoneNumberForDisplay = (phoneNumber) => {
  //   console.log("phoneNumber", phoneNumber)

  //   if (!phoneNumber) return '';

  //   const phoneStr = String(phoneNumber);
  //   if (phoneStr.startsWith('+')) {
  //     return phoneStr;
  //   }

  //   const countryCode = loggedEmployee?.countrycode || '';

  //   if (countryCode && !phoneStr.startsWith(countryCode.replace('+', ''))) {
  //     return countryCode + phoneStr;
  //   }

  //   return phoneStr;
  // };



  return (
    <>
      {isLoading ? <AdminLoader isLoading={isLoading} /> : <></>}
      <div className='flex justify-center align-middle items-center pt-2 pb-2'>
        <div className='bg-white w-[80%] rounded-md py-2'>
          <div className='flex gap-2 px-3 py-3 align-middle items-center'>
            <div className='bg-[#e8f0fe] rounded-md text-[#0f61e6] p-2'><ApartmentRoundedIcon /></div>
            <div>
              <h2 className='font-semibold '>Company Information</h2>
              <p className='text-xs'>Basic details about your organization</p>
            </div>
          </div>
          <div className='mainform px-3'>
            <div className='flex gap-2 py-2'>
              <div className='w-[50%]'>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  <ApartmentRoundedIcon fontSize='small' className='text-[#0f61e6]' /> Company Name <span className="text-red-700 text-xs">*</span>
                </div>
                <div>
                  <input
                    value={comapanyName}
                    className="border w-full bg-[#fcfcfc] border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs"
                    type="text"
                    placeholder="e.g. Acme Corporation"
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "");
                      setcomapanyName(value)
                      setisediting(true)
                    }}
                  />
                </div>
              </div>
              <div className='w-[50%]'>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  <LocalPostOfficeOutlinedIcon fontSize='small' className='text-[#0f61e6]' /> Company Email <span className="text-red-700 text-xs">*</span>
                </div>
                <div>
                  <input
                    value={comapanyEmail}
                    className="border w-full bg-[#fcfcfc] border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs"
                    type="text"
                    placeholder="hello@company.com"
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^a-zA-Z0-9@.]/g, "");
                      setcomapanyEmail(value)
                      setisediting(true)
                    }}

                  />
                </div>
              </div>
            </div>
            <div className='flex gap-2 py-2'>
              <div className='w-[50%]'>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  <CallOutlinedIcon fontSize='small' className='text-[#0f61e6]' /> Company Contact <span className="text-red-700 text-xs">*</span>
                </div>
                <div>
                  <PhoneInput
                    country={defaultCountry}
                    disableDropdown
                    countryCodeEditable={false}
                    value={comapanyContact}
                    onChange={(value) => {
                      setcomapanyContact(value)
                      setisediting(true)
                    }}
                    onlyCountries={allowedCountries}
                    preferredCountries={[]}
                    enableSearch={false}
                    inputProps={{
                      required: true,
                      className:
                        "w-full  border text-xs border-[#e5e7eb] bg-[#fcfcfc] outline-0 rounded  p-2 pl-10",
                    }}
                  />
                </div>
              </div>
              <div className='w-[50%]'>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  <LanguageOutlinedIcon fontSize='small' className='text-[#0f61e6]' /> Company Website
                </div>
                <div>
                  <input
                    value={comapanyLink}
                    className="border w-full bg-[#fcfcfc] border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs"
                    type="text"
                    placeholder="https://company.com"
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^a-zA-Z0-9:/.]/g, "");
                      setcomapanyLink(value)
                      setisediting(true)
                    }}

                  />
                </div>
              </div>
            </div>
            <div className='flex gap-2 py-2'>
              <div className='w-[50%]'>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  <PublicIcon fontSize='small' className='text-[#0f61e6]' /> Country
                </div>
                <div>
                  <input
                    value={defaultCountry === "in" ? "India" : defaultCountry === "us" ? "United States" : ""}
                    className="border w-full bg-[#fcfcfc] border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs"
                    type="text"
                    placeholder="123 Business Street"
                    onChange={(e) => {
                      setAddressLine1(e.target.value)
                      setisediting(true)
                    }}
                    readOnly
                  />
                </div>
              </div>
              <div className='w-[50%]'>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  <LocationOnOutlinedIcon fontSize='small' className='text-[#0f61e6]' /> Address Line1
                </div>
                <div>
                  <input
                    value={AddressLine1}
                    className="border w-full bg-[#fcfcfc] border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs"
                    type="text"
                    placeholder="123 Business Street"
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^a-zA-Z0-9 ,-]/g, "");
                      setAddressLine1(value)
                      setisediting(true)
                    }}

                  />
                </div>
              </div>
            </div>
            <div className='flex gap-2 py-2'>
              <div className='w-[50%]'>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  <LocationOnOutlinedIcon fontSize='small' className='text-[#0f61e6]' /> Address Line2
                </div>
                <div>
                  <input
                    value={AddressLine2}
                    className="border w-full bg-[#fcfcfc] border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs"
                    type="text"
                    placeholder="suite 100"
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^a-zA-Z0-9 ,-]/g, "");
                      setAddressLine2(value)
                      setisediting(true)
                    }}

                  />
                </div>
              </div>
              <div className='w-[50%]'>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  <HomeWorkOutlinedIcon fontSize='small' className='text-[#0f61e6]' /> Company City
                </div>
                <div>
                  <input
                    value={city}
                    className="border w-full bg-[#fcfcfc] border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs"
                    type="text"
                    placeholder="New York"
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "");
                      setcity(value)
                      setisediting(true)
                    }}
                  />
                </div>
              </div>

            </div>
            <div className='flex gap-2 py-2'>
              <div className='w-[50%]'>
                <div className='flex gap-1 pb-2 text-xs align-middle items-center font-semibold'>
                  <GpsFixedOutlinedIcon fontSize='small' className='text-[#0f61e6]' /> Pincode
                </div>
                <div>
                  <input
                    value={pincode}
                    maxLength={defaultCountry === "in" ? 6 : defaultCountry === "us" ? 10 : undefined}
                    className="border w-full bg-[#fcfcfc] border-[#e5e7eb] rounded-md p-2 overflow-hidden outline-none text-xs"
                    type="text"
                    placeholder={defaultCountry === "us" ? "12345-6789" : "123456"}
                    onChange={(e) => {
                      let value = e.target.value.replace(/\D/g, ""); // numbers only

                      if (defaultCountry === "in") {
                        // 🇮🇳 India: max 6 digits
                        value = value.slice(0, 6);
                        setpincode(value);
                      }

                      if (defaultCountry === "us") {
                        // 🇺🇸 US: ZIP + 4 (12345-6789)
                        value = value.slice(0, 9);

                        if (value.length > 5) {
                          value = `${value.slice(0, 5)}-${value.slice(5)}`;
                        }

                        setpincode(value);
                      }

                      setisediting(true);
                    }}
                  />

                </div>
              </div>
            </div>
            <div>
              <div className='flex gap-2 py-3 align-middle items-center'>
                <div className='bg-[#ecf3ff] rounded-md text-[#0f61e6] p-2'><FileUploadOutlinedIcon /></div>
                <div>
                  <h2 className='font-semibold '>Company Logo</h2>
                  <p className='text-xs'>Upload your company's brand logo</p>
                </div>
              </div>
              <div
                className={`relative w-full flex flex-col justify-center rounded-md align-middle items-center p-2 border-2 border-dashed transition-all duration-200 ${isDragging
                  ? 'border-blue-500 bg-blue-50 border-solid'
                  : 'border-gray-300 bg-[#f0f5ff] hover:border-blue-400 hover:bg-blue-50'
                  }`}
                onDragEnter={handleDragEnter}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                {/* Hidden file input */}
                <input
                  ref={fileInputRef}
                  id="fileUpload"
                  type="file"
                  className="hidden"
                  accept=".png,.jpg,.jpeg,image/png,image/jpeg,image/jpg"
                  onChange={handleInputChange}
                />
                {/* Drag overlay indicator - Only show when actually dragging */}
                {isDragging && (
                  <div className="absolute inset-0 bg-blue-500 bg-opacity-10 flex items-center justify-center rounded-md z-10 pointer-events-none">
                    <div className="text-center bg-white/90 p-6 rounded-lg shadow-lg">
                      <div className="bg-blue-100 rounded-full p-4 mb-3 inline-block">
                        <FileUploadOutlinedIcon className="text-blue-600" fontSize="large" />
                      </div>
                      <p className="text-blue-700 font-semibold text-sm">Drop to upload your logo</p>
                      <p className="text-blue-600 text-xs mt-1">PNG, JPG files only</p>
                    </div>
                  </div>
                )}
                {/* Clickable upload area */}
                <label
                  htmlFor="fileUpload"
                  className={`cursor-pointer flex flex-col items-center justify-center w-full min-h-[120px] ${isDragging ? 'opacity-50' : ''
                    }`}
                >
                  <div className={`rounded-full inline-block p-3 mb-3 transition-all duration-200 ${companyLogo
                    ? 'bg-green-100 text-green-600 ring-2 ring-green-300'
                    : 'bg-[#dae7fe] text-[#0f61e6] hover:bg-blue-200'
                    }`}>
                    {companyLogo ? (
                      <CheckCircleOutlinedIcon fontSize="large" />
                    ) : (
                      <FileUploadOutlinedIcon fontSize="large" />
                    )}
                  </div>

                  <div className='text-xs font-semibold text-center mb-2'>
                    <div className='flex justify-center items-center gap-1'>
                      <p className='text-[#0f61e6]'>Click to upload</p>
                      <span className="text-gray-400">or</span>
                      <p className='text-gray-600'>drag and drop</p>
                    </div>
                    <p className="text-gray-500 mt-1">PNG, JPG (Max 2MB)</p>
                  </div>
                </label>
                {/* Selected file info */}
                {companyLogo && (
                  <div className="mt-4 w-full max-w-md animate-fadeIn">
                    <div className="flex items-center justify-between bg-green-50 p-3 rounded-lg border border-green-200">
                      <div className="flex items-center gap-3">
                        <div className="bg-green-100 p-2 rounded">
                          <FileUploadOutlinedIcon className="text-green-600" fontSize="small" />
                        </div>
                        <div className="max-w-[200px]">
                          <p className="text-sm font-medium text-gray-800 truncate">{companyLogo.name}</p>
                          <p className="text-xs text-gray-500">
                            {(companyLogo.size / 1024).toFixed(2)} KB
                          </p>
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={handleClearFile}
                        className="text-xs bg-red-100 text-red-600 px-3 py-1 rounded hover:bg-red-200 transition-colors whitespace-nowrap"
                      >
                        Remove
                      </button>
                    </div>
                    {/* Preview */}
                    <div className="mt-3 flex justify-center">
                      <img
                        src={URL.createObjectURL(companyLogo)}
                        alt="Preview"
                        className="h-32 w-32 object-contain border rounded-lg shadow-sm"
                      />
                    </div>
                  </div>
                )}
                {/* Show existing logo if no new file selected */}
                {oldLogo && !companyLogo && (
                  <div className="mt-2 flex justify-center align-middle items-center w-full gap-1">
                    <p className=" text-gray-600 flex text-xs">Current Logo:</p> <p className='hover:text-blue-600 text-xs cursor-pointer' onClick={handleDownload}>{oldLogoFileName}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className='flex justify-end items-center pt-2 px-3'>
            <button disabled={!isediting} onClick={handleProfile} className={`py-1 px-3 rounded-lg ${isediting ? "bg-[#0f61e6]" : "bg-blue-200"}  font-semibold text-white text-xs`}>
              <TaskAltIcon fontSize='small' /> Create Company Profile
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyProfile;



